import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';

import { RiskIdentificationDTO, RiskIdentificationFilters } from '../../models/risk-identification.model';

@Injectable({
  providedIn: "root"
})
export class LaravelRiskIdentificationService {
  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
      list: environment.baseUrl + "/api/risk_identifications",
      show: environment.baseUrl + "/api/risk_identification",
      store: environment.baseUrl + "/api/risk_identification",
      destroy: environment.baseUrl + "/api/risk_identification",
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: RiskIdentificationFilters,
    includes?: string[]
  ): Observable<ListResultDTO<RiskIdentificationDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
    }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<RiskIdentificationDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<RiskIdentificationDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public show(id: number): Observable<RiskIdentificationDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<RiskIdentificationDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(risk_identification: RiskIdentificationDTO): Observable<RiskIdentificationDTO> {
    if (risk_identification.id) {
      return this.httpClient.put<RiskIdentificationDTO>(`${this.ROUTES.store}`, { risk_identification });
    } else {
      return this.httpClient.post<RiskIdentificationDTO>(`${this.ROUTES.store}`, { risk_identification });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
